import axios from "axios";

export default {
	listTemplates(ctx) {
		return axios.get("/v3/templates", {
			params: ctx
		});
	},

	getTemplate(id) {
		return axios.get(`/v3/template/${id}`);
	},

	saveTemplate(item) {
		return axios.post("/v3/admin/template", item);
	},

	removeTemplate(id) {
		return axios.delete(`/v3/admin/template/${id}`);
	},


};



// WEBPACK FOOTER //
// ./src/services/TemplateService.js